import { ApplicationResourcesFormat } from '@/application/ApplicationResourcesFormat'
import GameSignals from '@/signals/GameSignals'
import { ModulesManager as modulesManager } from '@modules/src/managers/ModulesManager'
import { DeviceUtils } from '@modules/src/utils/DeviceUtils'
import { Assets } from 'pixi.js'
import * as WebFont from 'webfontloader'
import { buildAssetUrl } from '@/utils/AssetsUrlUtil'
import { loadGeneratedSpritesheets } from '@/assets/loadGeneratedSpritesheets'

export class ApplicationLoader {
    public static readonly SPINE_ATLASES_URL: string = buildAssetUrl('/assets/spritesheets/animations_{v}_{n1}.json')
    public static readonly DESKTOP_ATLASES_COUNT: number = 0
    public static readonly MOBILE_ATLASES_COUNT: number = 0

    public static async loadPreloadingAssets() {
        try {
            await modulesManager.preloadAssets()
            this.onLoadPreloadingAssetsComplete()
        } catch (error) {
            console.error('Error loading preload assets:', error)
        }
    }

    private static onLoadPreloadingAssetsComplete = () => {
        GameSignals.preloaderAssetsLoadingComplete.emit()
    }

    public static async loadMainGameAssets() {
        try {
            await modulesManager.loadMainAssets()
            await loadGeneratedSpritesheets()

            if (ApplicationResourcesFormat.MERGED_SPINE_ATLASES_ENABLED) {
                const { SPINE_ATLASES_URL, DESKTOP_ATLASES_COUNT, MOBILE_ATLASES_COUNT } = ApplicationLoader
                const channelAtlasesCount = DeviceUtils.isMobileDevice() ? MOBILE_ATLASES_COUNT : DESKTOP_ATLASES_COUNT
                const channelType = DeviceUtils.isMobileDevice() ? 'mobile' : 'desktop'
                console.log('Loading spine atlases:', channelAtlasesCount)
                
                const atlasPromises = []
                for (let index = 0; index < channelAtlasesCount; index++) {
                    const spineAtlasUrl = SPINE_ATLASES_URL.replace('{v}', channelType).replace('{n1}', (index + 1).toString())
                    atlasPromises.push(Assets.load(spineAtlasUrl))
                }
                
                await Promise.all(atlasPromises)
            }

            this.onLoadMainGameAssetsComplete()
        } catch (error) {
            console.error('Error loading main game assets:', error)
        }
    }

    private static onLoadMainGameAssetsComplete = () => {
        GameSignals.mainGameAssetsLoadingComplete.emit()
    }

    public static async loadGameFonts(): Promise<void> {
        return new Promise((resolve, reject) => {
            const fontsUrl = buildAssetUrl('/assets/fonts/stylesheet.css')
            console.log('Loading fonts from:', fontsUrl)
            
            WebFont.load({
                active: () => {
                    console.log('Fonts loaded successfully')
                    resolve()
                },
                inactive: () => {
                    console.warn('Fonts loading inactive/timeout')
                    resolve() // Don't block if fonts fail
                },
                
                custom: {
                    families: ['Rubik_Game', 'Roboto-Black', 'Montserrat', 'Montserrat_Bold'],
                    urls: [fontsUrl],
                },
            })
        })
    }
}
